<template>
  <form class="shadow postcardMobile-comp" :class="{ 'active-style_Anhang': anhangButton, 'unapproved': !postcard_info.approved && !postcard_info.readOnly}"
    :style="{ height: postcardHeight }" action="" ref="postcardFront">
    <div class="postcard">
      <div v-if="!attachmentShown" class="postcard__front">
        <div class="postcard__top">
          <div class="grid-container">
            <div class="postcard__sender">
              <ul>
                <li>Absender*in</li>
                <li>
                  <div v-if="
                    postcard_info.readOnly ||
                    postcard_info.topicFixed ||
                    postcard_info.sentFrom !== 'Mailbox'
                  ">
                    <!-- TODO when someone writes a postcard, the postcard already has to know if the user is verified to show this here -->
                    <b :class="'verified--' + postcard_info.sender_verified">{{ postcard_info.sender }}&nbsp;<v-img
                        v-if="postcard_info.sender_verified" class="verified-icon"
                        src="../../../client-shared/img/verification_hubbel_v01.svg" alt="(verified)" width="18"
                        tabindex="1" />
                    </b>
                  </div>
                  <div v-else class="selectQuestion">
                    <v-text-field v-model="senderName" dense clearable />
                  </div>
                </li>
              </ul>
            </div>
            <div class="postcard__subject">
              <ul>
                <li>Thema:</li>
                <li>
                  <div v-if="postcard_info.readOnly || postcard_info.topicFixed">
                    <router-link :to="`/Forum/${postcard_info.subject}`" class="subject__link">
                      <b>{{ postcard_info.subject }}</b>
                    </router-link>
                  </div>
                  <div v-else class="selectQuestion">
                    <select v-model="selectedTopic">
                      <option v-for="topic in possibleTopics" :key="topic.topic_id" :value="topic.topic_id"
                        :title="topic.name">
                        {{
                          topic.name.substr(0, 15) + (topic.name.length > 15 ? "..." : "")
                          /*TODO: A line-break would be preferred here*/
                        }}
                      </option>
                    </select>
                  </div>
                </li>
              </ul>
            </div>
            <div class="logo_wrapper">
              <v-img v-if="
                postcard_info.readOnly &&
                ['PC', 'Phone', 'Mailbox'].includes(postcard_info.sentFrom)
              " :alt="'Created from ' + postcard_info.sentFrom" contain :src="require(`../../../client-shared/img/stamp_${postcard_info.sentFrom.toLowerCase()}.svg`)
                " class="img-stamp" />
              <v-img alt="hubbel image"
                     contain
                     :src="
                       Number.isFinite(postcard_info.id)
                       ? require(`../../../client-shared/img/stamp${Number(postcard_info.id)  % 4}.jpg`)
                       : require ('../../../client-shared/img/hubbel_logo.svg')"
                     class="img-stamp--mobile-stamp" />
            </div>
            <div class="postcard__date">
              <ul>
                <li>
                  {{ getDateString(postcard_info.date) }}
                </li>
              </ul>


              <div v-if="
                loggedInUser != null &&
                loggedInUser.level_of_user !== 'normal' &&
                !postcard_info.readOnly
              " class="postcard__moderation">
                <v-btn elevation="1" outlined class="approvePost" @click="approve(postcard_info)">freischalten</v-btn>
                <v-btn elevation="1" outlined class="deletePost" @click="hide(postcard_info)">löschen</v-btn>
              </div>
              <div v-if="
                loggedInUser != null &&
                loggedInUser.level_of_user !== 'normal' &&
                postcard_info.readOnly &&
                postcard_info.approved
              " class="postcard__moderation">
                <v-btn elevation="1" outlined small class="editPost custom-btn" @click="makePostcardEditable()">
                  <v-icon medium>mdi-pencil</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="postcard__horizontal-line" />
        <div class="postcard__bottom">
          <div class="postcard_category">
            <div v-if="postcard_info.readOnly || postcard_info.topicFixed">
              <label v-if="postcard_info.category === 'Information'"
                class="postcard__category postcard__category--information">Information
              </label>
              <label v-if="postcard_info.category === 'Question'"
                class="postcard__category postcard__category--question">Frage
              </label>
              <label v-if="postcard_info.category === 'Event'"
                class="postcard__category postcard__category--event">Veranstaltung
              </label>
              <label v-if="postcard_info.category === 'Answer'"
                class="postcard__category postcard__category--answer">Answer
              </label>
            </div>
            <div v-else class="selectInformation" :class="'selectInformation--' + category">
              <select v-model="category">
                <option value="Information">Information</option>
                <option value="Question">Frage</option>
                <option value="Event">Event</option>
                <option value="Answer">Answer</option>
              </select>
            </div>
          </div>
          <div>
            <div v-if="postcard_info.readOnly" class="postcard__message font-regular" :class="{
              'postcard__message--moderationAdjustment':
                loggedInUser != null && loggedInUser.level_of_user !== 'normal',
            }" ref="scrollContainer" @scroll.passive="toggleShadow">
              <!-- https://markus.oberlehner.net/blog/scrolling-shadows-with-vue/ -->
              <!-- <span v-if="shadow.top" class="shadow-top is-active" /> -->
              <span v-if="shadow.bottom" class="shadow-bottom is-active" />

              <span v-if="
                postcard_info.approved ||
                (loggedInUser != null && postcard_info.sender === fullName(loggedInUser))
              ">
              <template v-if="postcard_info.category === 'Event' || this.getCategory() === 'Event'">
                <div class="row-flex">
                  <p>Titel: </p>
                  <p><b>{{ postcard_info.eventTitle }}</b> </p>
                </div>
                <div class="row-flex">
                  <p>Termin: </p>
                  <p><b> {{ formatEventDate(postcard_info) }}</b></p>
                </div>
                 <div class="row-flex">
                   <p>Ort: </p>
                   <p><b>{{ postcard_info.eventLocation }}</b></p>
                 </div>
              </template>
              {{ postcard_info.text }}
              </span>
              <span v-else class="dummyText">
                {{ dummyText }}
              </span>
            </div>
            <div v-else>
              <div v-if="postcard_info.category === 'Event' || this.getCategory() === 'Event'">
                <p class="text-left">Titel</p>
                <input v-model="eventTitle" id="title" type="text" placeholder="Titel" class="postcard__input postcard__input--editable"/>
                <div class="column-flex">
                  <div class="mr-2">
                    <p class="text-left">Beginn</p>
                    <div>
                      <input ref="startDateInput" v-model="eventStartDate" type="date" @click="openNativePicker('startDate')" @focus="openNativePicker('startDate')" :min="startMinDate" style="max-width: 195px;" class="postcard__input postcard__input--editable postcard__input--compact"/>
                      <input ref="startTimeInput" v-model="eventStartTime" type="time"  @click="openNativePicker('startTime')" @focus="openNativePicker('startTime')" style="max-width: 187px; margin-left: 5px;" step="60" class="postcard__input postcard__input--editable postcard__input--compact"/>
                    </div>
                  </div>
                  <div></div>
                  <div>
                    <p class="text-left">Ende</p>
                    <div>
                      <input ref="endDateInput" v-model="eventEndDate" type="date" @click="openNativePicker('endDate')" @focus="openNativePicker('endDate')" style="max-width: 195px;" :min="endMinDate" class="postcard__input postcard__input--editable postcard__input--compact"/>
                      <input ref="endTimeInput" v-model="eventEndTime" type="time" @click="openNativePicker('endTime')" @focus="openNativePicker('endTime')" style="max-width: 187px; margin-left: 5px;" step="60" :min="endMinTimeIfSameDay" class="postcard__input postcard__input--editable postcard__input--compact"/>
                    </div>
                  </div>
                </div>
                <p class="text-left">Ort</p>
                <input v-model="eventLocation" id="location" type="text" placeholder="Ort" class="postcard__input postcard__input--editable"/>
                <p></p>
              </div>
              <textarea v-model="writtenText" class="postcard__message postcard__message--editable font-regular"
                name="message" maxlength="500" rows="12" cols="40" :placeholder="postcard_info.text.length > 0
                  ? postcard_info.text
                  : 'Inhalt (maximal 500 Zeichen)'
                  " />
              <!-- <v-icon class="message__paper-clip" @click="openInput()"> $paperclip </v-icon> -->
              <span class="message__text-length">{{ writtenText.length }}/500</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="attachmentShown" class="postcard__back">
        <Attachment :attachments="attachments" :postcard_id="postcard_info.id" :read-only="postcard_info.readOnly"
          @deleteAttachment="deleteAttachment" @openInput="openInput()" />
      </div>
    </div>
    <!-- <Button v-if="!postcard_info.readOnly || (attachments.length > 0 && postcard_info.approved)" id="attachmentSwitcher"
      :is-anhang="true" icon="paperclip" :label_text="attachmentShown
        ? 'Postkarte'
        : attachments.length === 0
          ? 'Anhang hinzufügen'
          : attachments.length + (attachments.length === 1 ? ' Anhang' : ' Anhänge')
        " class="postcard__attachment-switcher" @click.native="toggleAttachment($event)" /> -->
    <Button v-if="!postcard_info.readOnly || (attachments.length > 0 && postcard_info.approved)" id="attachmentSwitcher"
      :is-anhang="true"
      :icon="attachmentShown ? 'postcard' : 'paperclip'"
      :label_text="attachmentShown ? '' : attachments.length === 0 ? 'Anhang hinzufügen' : ''"
      class="postcard__attachment-switcher" :class="{ 'unapproved': !postcard_info.approved}"  @click.native="toggleAttachment($event)">
      <!-- Bubble showing number of attachments, hidden if backside of postcard is shown -->
      <!-- <span v-if="attachments.length > 0 && !attachmentShown" class="attachment-bubble"> {{ attachments.length }}</span> -->
    </Button>
    <input v-if="!postcard_info.readOnly" id="fileChooser" type="file" class="fileChooser" accept="image/*,.pdf"
      multiple @change="uploadAttachments()" />
  </form>
</template>

<script>
import Button from "@/components/Button";
import Attachment from "@/components/Attachment";
import { baseURL } from "@/services/api";
import Api from "../services/api";

export default {
  name: "PostCard",
  components: {
    Attachment,
    Button,
  },
  props: {
    postcard_info: { type: Object },
    loggedInUser: { type: Object },
  },
  // data: () => ({
  //   writtenText: null,
  //   category: null,
  //   selectedTopic: null,
  //   senderName: null,
  //   possibleTopics: [],
  //   attachmentShown: false,
  //   attachments: [],
  //   postcardHeight: 'auto'
  // }),
  data() {
    return {
      writtenText: null,
      eventTitle: null,
      eventLocation: null,
      eventStartDateTime: null,
      eventEndDateTime: null,
      eventStartDate: null,
      eventStartTime: null,
      eventEndDate: null,
      eventEndTime: null,
      category: null,
      selectedTopic: null,
      senderName: null,
      possibleTopics: [],
      attachmentShown: false,
      attachments: [],
      postcardHeight: 'auto',
      shadow: {
        // top: false,
        bottom: false,
      },
    };
  },
  computed: {
    isEditingExistingEvent() {
      const pc = this.postcard_info || {};
      return Boolean(pc.id && pc.eventStartDateTime);
    },

    startMinDate() {
      // beim Neuanlegen: heute; beim Editieren: min entfernen
      return this.isEditingExistingEvent ? null : this.todayDate;
    },

    dummyText() {
      return "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.";
    },
    todayDate() {
      const d = new Date();
      // lokales Datum (keine UTC-Verschiebung)
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    },
    //Used to set the class of the mobilecomp depending on the componentes (buttons) displayed inside of it
    anhangButton() {
      return !this.postcard_info.readOnly || (this.attachments.length > 0 && this.postcard_info.approved);
    },

    /*// Ende darf nie vor Start liegen
    effectiveEndMin() {
      if (!this.eventStartDateTime) return null
      const start = new Date(this.eventStartDateTime)
      if (isNaN(start.getTime())) return null
      start.setMinutes(start.getMinutes() + 1)
      return this.toLocalIsoNoTZ(start)
    },*/

    endMinDate() {
      return this.eventStartDate || this.todayDate;
    },
    endMinTimeIfSameDay() {
      if (!this.eventStartDate || !this.eventStartTime) return null;
      if (this.eventEndDate !== this.eventStartDate) return null;

      const s = this.parseLocalDateTime(`${this.eventStartDate}T${this.eventStartTime}`);
      if (!s) return null;
      s.setMinutes(s.getMinutes() + 1);
      return this.toLocalIsoNoTZ(s).slice(11, 16);
    },
  },
  watch: {
    writtenText: function (val, oldVal) {
      if (val !== oldVal) this.$emit("writtenTextChanged", val);
    },
    eventTitle: function (val, oldVal) {
      if (val !== oldVal) this.$emit("eventTitleChanged", val);
    },
    eventLocation: function (val, oldVal) {
      if (val !== oldVal) this.$emit("eventLocationChanged", val);
    },
    eventStartDate() {
      if (!this.isEditingExistingEvent) {
        this.ensureStartDateNotBeforeToday();
      }
      this.ensureEndDateNotBeforeStartDate();
      this.syncStartDateTime();
    },
    eventEndDate() {
      this.ensureEndDateNotBeforeStartDate();
      this.syncEndDateTime(); // optional: wenn Endzeit schon da ist, direkt updaten
    },

    eventStartTime() { this.syncStartDateTime(); },
    eventEndTime()   { this.syncEndDateTime(); },

    /*eventStartDateTime(val, oldVal) {
      if (!val) return
      // Falls Ende nicht nach Start liegt, auf Start+1min setzen
      if (this.eventEndDateTime && new Date(this.eventEndDateTime) <= new Date(val)) {
        const newEnd = new Date(val)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
      if (val !== oldVal) this.$emit("eventStartDateTimeChanged", this.eventStartDateTime)
    },
    eventEndDateTime(val, oldVal) {
      if (!val) return
      if (this.eventStartDateTime && new Date(val) <= new Date(this.eventStartDateTime)) {
        const newEnd = new Date(this.eventStartDateTime)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
      if (val !== oldVal) this.$emit("eventEndDateTimeChanged", this.eventEndDateTime)
    },*/
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.toggleShadow();
    // });
  },
  created() {
    this.attachments = this.postcard_info.attachments
      ? this.renderAttachments(this.postcard_info.attachments)
      : [];
    this.writtenText = this.postcard_info.text;
    this.eventTitle = this.postcard_info.eventTitle;
    this.eventLocation = this.postcard_info.eventLocation;
    this.eventStartDateTime = this.postcard_info.eventStartDateTime;
    this.eventEndDateTime = this.postcard_info.eventEndDateTime;
    this.splitDateTimeToFields();
    this.category = this.postcard_info.category;
    this.senderName = this.postcard_info.sender_name_mailbox;

    this.possibleTopics = this.postcard_info.allTopicNames || [];
    this.selectedTopic =
      this.possibleTopics.find((elem) => elem.name === this.postcard_info.subject)?.topic_id || 0;
  },
  methods: {

    openNativePicker(which) {
      const map = {
        startDate: "startDateInput",
        startTime: "startTimeInput",
        endDate: "endDateInput",
        endTime: "endTimeInput",
      };

      const refName = map[which];
      const el = this.$refs[refName];
      if (!el) return;

      // Chrome/Edge: öffnet den nativen Picker direkt
      if (typeof el.showPicker === "function") {
        el.showPicker();
        return;
      }

      // Fallback (Safari/Firefox): zumindest fokussieren
      el.focus();
    },

    ensureStartDateNotBeforeToday() {
      if (!this.eventStartDate) return;
      if (this.eventStartDate < this.todayDate) {
        this.eventStartDate = this.todayDate;

        // optional: wenn du willst, dass Ende direkt mitgezogen wird:
        this.ensureEndDateNotBeforeStartDate();
      }
    },

    ensureEndDateNotBeforeStartDate() {
      if (!this.eventStartDate || !this.eventEndDate) return;

      // string-compare geht bei YYYY-MM-DD korrekt
      if (this.eventEndDate < this.eventStartDate) {
        // Variante A (streng): sofort auf Startdatum setzen
        this.eventEndDate = this.eventStartDate;

        // wenn Ende-Uhrzeit existiert UND gleicher Tag → min time erzwingen
        if (this.eventEndTime && this.eventStartTime) {
          const minTime = this.endMinTimeIfSameDay; // "HH:mm" oder null
          if (minTime && this.eventEndTime < minTime) {
            this.eventEndTime = minTime;
          }
        }
      }
    },

    formatEventDate(pc) {
      if (!pc || !pc.eventStartDateTime) return "";

      const s = new Date(pc.eventStartDateTime);
      const e = pc.eventEndDateTime ? new Date(pc.eventEndDateTime) : null;

      const pad = n => String(n).padStart(2, "0");
      const fmtDate = d => `${pad(d.getDate())}.${pad(d.getMonth()+1)}.${String(d.getFullYear()).slice(2)}`;
      const fmtTime = d => `${pad(d.getHours())}:${pad(d.getMinutes())}`;

      const startDate = fmtDate(s);
      const startTime = fmtTime(s);

      if (!e || isNaN(e.getTime())) {
        // kein Enddatum → nur Start anzeigen
        return `${startDate}, ${startTime}`;
      }

      const endDate = fmtDate(e);
      const endTime = fmtTime(e);

      const isSameDay =
        s.getFullYear() === e.getFullYear() &&
        s.getMonth() === e.getMonth() &&
        s.getDate() === e.getDate();

      //Eintägig → Datum einmal, Zeiten Start–Ende
      if (isSameDay) {
        return `${startDate}, ${startTime} – ${endTime}`;
      }

      //Mehrtägig → Datum + Zeit beides anzeigen
      return `${startDate}, ${startTime} – ${endDate}, ${endTime}`;
    },

    syncStartDateTime() {
      const combined = this.combineDateTime(this.eventStartDate, this.eventStartTime);
      if (combined === this.eventStartDateTime) return;
      this.eventStartDateTime = combined;

      this.ensureEndAfterStart();
      this.$emit("eventStartDateTimeChanged", this.eventStartDateTime);
    },

    syncEndDateTime() {
      const combined = this.combineDateTime(this.eventEndDate, this.eventEndTime);
      if (combined === this.eventEndDateTime) return;
      this.eventEndDateTime = combined;

      this.ensureEndAfterStart();
      this.$emit("eventEndDateTimeChanged", this.eventEndDateTime);
    },

    combineDateTime(date, time) {
      if (!date || !time) return null;
      return `${date}T${time}`; // genau DB-Format
    },

    parseLocalDateTime(s) {
      if (!s) return null;
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
      if (!m) return null;
      const [_, Y, Mo, D, H, Mi] = m;
      return new Date(+Y, +Mo - 1, +D, +H, +Mi, 0, 0);
    },

    ensureEndAfterStart() {
      if (!this.eventStartDateTime || !this.eventEndDateTime) return;

      const s = this.parseLocalDateTime(this.eventStartDateTime);
      const e = this.parseLocalDateTime(this.eventEndDateTime);
      if (!s || !e) return;

      if (e <= s) {
        const newEnd = new Date(s);
        newEnd.setMinutes(newEnd.getMinutes() + 1);
        const iso = this.toLocalIsoNoTZ(newEnd);

        this.eventEndDateTime = iso;
        this.eventEndDate = iso.slice(0, 10);
        this.eventEndTime = iso.slice(11, 16);
        this.$emit("eventEndDateTimeChanged", this.eventEndDateTime);
      }
    },

    splitDateTimeToFields() {
      const split = (dt) => {
        if (!dt) return { date: null, time: null };
        const norm = this.toLocalIsoNoTZ(dt);
        if (!norm) return { date: null, time: null };
        return { date: norm.slice(0, 10), time: norm.slice(11, 16) };
      };

      const s = split(this.eventStartDateTime);
      this.eventStartDate = s.date;
      this.eventStartTime = s.time;

      const e = split(this.eventEndDateTime);
      this.eventEndDate = e.date;
      this.eventEndTime = e.time;
    },


    toLocalIsoNoTZ(value) {
      // gibt "YYYY-MM-DDTHH:mm" zurück (ohne Sekunden/Timezone)
      if (!value) return null
      if (typeof value === 'string') {
        const re = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/
        if (re.test(value)) return value.slice(0, 16)
        const d = new Date(value)
        if (!isNaN(d.getTime())) return this.toLocalIsoNoTZ(d)
        return null
      }
      const d = value instanceof Date ? value : new Date(value)
      if (isNaN(d.getTime())) return null
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
    },

    /*onStartChange() {
      if (this.eventStartDateTime && this.eventEndDateTime && new Date(this.eventEndDateTime) <= new Date(this.eventStartDateTime)) {
        const newEnd = new Date(this.eventStartDateTime)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
    },

    onEndChange() {
      if (this.eventStartDateTime && this.eventEndDateTime && new Date(this.eventEndDateTime) <= new Date(this.eventStartDateTime)) {
        const newEnd = new Date(this.eventStartDateTime)
        newEnd.setMinutes(newEnd.getMinutes() + 1)
        this.eventEndDateTime = this.toLocalIsoNoTZ(newEnd)
      }
    },*/

    formatDateTime(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(d);
    },
    makePostcardEditable() {
      this.postcard_info.readOnly = false;
    },
    approve(postcard) {
      this.$confirm({
        title: "Freischalten?",
        message: "Soll die Postkarte endgültig freigeschaltet werden?",
        button: {
          no: "Nein, abbrechen!",
          yes: "Ja, freischalten!",
        },
        callback: (confirm) => {
          if (confirm) {
            postcard.text = this.getText();
            postcard.eventTitle = this.getEventTitle();
            postcard.eventLocation = this.getEventLocation();
            postcard.eventStartDateTime = this.getEventStartDateTime();
            postcard.eventEndDateTime = this.getEventEndDateTime();
            postcard.category = this.getCategory();
            postcard.topic_id = this.getSelectedTopic();
            postcard.sender_name = this.getSenderName();
            Api.updateAndApprovePostcard(postcard).then((res) => {
              if (res.status === 200) this.$router.go(0); // Refreshes site if approval was successful
            });
          }
        },
      });
    },
    hide(postcard) {
      this.$confirm({
        title: "Löschen?",
        message: "Soll die Postkarte endgültig gelöscht werden?",
        button: {
          no: "Nein, abbrechen!",
          yes: "Ja, löschen!",
        },
        callback: (confirm) => {
          if (confirm) {
            Api.hidePostcard(postcard).then((res) => {
              if (res.status === 200) this.$router.go(0); // Refreshes site if approval was successful
            });
          }
        },
      });
    },
    fullName(loggedInUser) {
      return loggedInUser.first_name + " " + loggedInUser.last_name;
    },
    getText() {
      return this.writtenText || "empty";
    },
    getEventTitle() {
      return this.eventTitle || null;
    },
    getEventLocation() {
      return this.eventLocation || null;
    },
    getEventStartDateTime() {
      return this.eventStartDateTime || null;
    },
    getEventEndDateTime() {
      return this.eventEndDateTime || null;
    },
    getCategory() {
      return this.category || false;
    },
    getSelectedTopic() {
      return this.selectedTopic || "";
    },
    getSenderName() {
      return this.senderName || "";
    },
    getDateString(cardDate) {
      const date = new Date(cardDate.replace(/\s/, "T") + "Z"); // https://stackoverflow.com/questions/21883699/safari-javascript-date-nan-issue-yyyy-mm-dd-hhmmss
      let dateString;

      dateString =
        ("0" + date.getDate()).slice(-2) +
        "." +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "." +
        date.getFullYear();

      return dateString;
    },
    //Sets the height of the postcard wrapper when the backside is displayed, to be identical witht the frontside
    setPostcardWrapperHeight() {
      const height = this.$refs.postcardFront.clientHeight + 'px';
      this.$nextTick(() => {
        if (height) {
          this.postcardHeight = height;
        }
      });
    },
    getAttachments() {
      return this.attachments;
    },
    renderAttachments(attachments) {
      const att = [];
      attachments.forEach((attach) => {
        att.push({
          name: attach.name,
          type: attach.static_file_path.split(".").pop(),
          src: baseURL + "public/" + attach.static_file_path,
        });
      });
      return att;
    },
    pushRenderedAttachments(attachments) {
      this.attachments = attachments;
    },
    openInput() {
      document.getElementById("fileChooser").click();
    },
    uploadAttachments() {
      let fileList = document.getElementById("fileChooser").files;
      const attachments = this.attachments;

      if (!fileList) return;

      for (let i = 0; i < fileList.length; i++) {
        //const serverUrl = uploadToServer(fileList[i]);

        const fileReader = new FileReader();
        fileReader.readAsDataURL(fileList[i]);
        fileReader.addEventListener("load", function () {
          attachments.push({
            name: fileList[i].name,
            type: fileList[i].type.split("/")[1],
            //src: serverUrl
            src: this.result,
          });
        });
      }
      this.attachmentsVisualFeedback();
    },

    deleteAttachment(index) {
      this.attachments.splice(index, 1);
    },

    toggleAttachment(event) {
      event.stopPropagation();
      this.attachmentShown = !this.attachmentShown;
      if (this.attachmentShown) {
        this.setPostcardWrapperHeight();
      }
      if (
        this.attachmentShown &&
        this.attachments.length > 0 &&
        this.postcard_info.id !== undefined &&
        this.postcard_info.id !== null &&
        typeof this.postcard_info.id !== "undefined"
      ) {
        window._paq.push([
          "trackEvent",
          "Attachments",
          "Attachments Click",
          "Attachment Section of Postcard " + this.postcard_info.id + " selected",
        ]);
      }
    },

    attachmentsVisualFeedback() {
      const switcher = document.getElementById("attachmentSwitcher");
      const initialColor = switcher.style.backgroundColor;
      const hoverColor = "#c5e388"; //TODO make class

      switcher.style.backgroundColor = hoverColor;

      setTimeout(() => {
        switcher.style.backgroundColor = initialColor;
      }, 200);
      setTimeout(() => {
        switcher.style.backgroundColor = hoverColor;
      }, 400);
      setTimeout(() => {
        switcher.style.backgroundColor = initialColor;
      }, 600);
    },

    // toggleShadow() {
    //   const hasVerticalScrollbar = this.$refs.scrollContainer.clientHeight < this.$refs.scrollContainer.scrollHeight;

    //   const scrolledFromTop = this.$refs.scrollContainer.offsetHeight + this.$refs.scrollContainer.scrollTop;

    //   // const scrolledToTop = this.$refs.scrollContainer.scrollTop === 0;
    //   const scrolledToBottom = scrolledFromTop >= this.$refs.scrollContainer.scrollHeight;

    //   // this.shadow.top = hasVerticalScrollbar && !scrolledToTop;
    //   this.shadow.bottom = hasVerticalScrollbar && !scrolledToBottom;
    // },
  },
};
</script>
